import { render } from "./ImgDimensionTubPerfComponent.vue?vue&type=template&id=9c8fb188&scoped=true"
import script from "./ImgDimensionTubPerfComponent.vue?vue&type=script&lang=js"
export * from "./ImgDimensionTubPerfComponent.vue?vue&type=script&lang=js"

import "./ImgDimensionTubPerfComponent.vue?vue&type=style&index=0&id=9c8fb188&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8fb188"]])

export default __exports__